"use strict";
var forms_1 = require('@angular/forms');
var lang_1 = require('../facade/lang');
exports.number = function (control) {
    if (lang_1.isPresent(forms_1.Validators.required(control)))
        return null;
    var v = control.value;
    return /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(v) ? null : { 'number': true };
};
//# sourceMappingURL=validator.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-validation/dist/number/validator.js
// module id = 1207
// module chunks = 16